angular.module('rjmNg.api').factory('Columns', [
  "serviceUrl"
  "app"
  "modelFactory"
  "$q"
  (serviceUrl, app, modelFactory, $q) ->
    Columns = modelFactory serviceUrl("/clients/#{app.getClientId()}/columns"),
      httpConfig:
        withCredentials: true
      cacheOptions:
        deleteOnExpire: 'passive'
        maxAge: (60*60*1000) # one hour

    getReferenceColumn = (localColumnPromise) ->
      deferred = $q.defer()
      localColumnPromise.then (localColumn) ->
        Columns.get(localColumn.reference_column_id).then (c) ->
          deferred.resolve c
        , ->
          deferred.reject()
      , ->
        deferred.reject()
      return deferred.promise

    traceJoins = (column) ->
      promises = []
      for join in column.properties.joins
        for localColumnId, idx in join.local_column_ids
          localColumnPromise = Columns.get(localColumnId)
          promises.push localColumnPromise
          if column.properties.derivative_type == "relocated_field"
            promises.push getReferenceColumn(localColumnPromise)
          else
            promises.push Columns.get(join.foreign_column_ids[idx])
      return promises

    relocAggDependencies = (column) ->
      promises = traceJoins(column)
      if column.properties.derivative_type == "relocated_field"
        promises.push Columns.get(column.properties.source_column_id)
      else
        promises.push Columns.get(column.properties.operand_column_id)
      return promises

    Columns.immediateDependencies = (column) ->
      if column.type != "derivative"
        d = $q.defer()
        d.resolve []
        return d.promise

      props = column.properties
      switch props.derivative_type
        when "year", "quarter", "month", "day", "hour", "email_domain", \
             "region_large", "region_small", "state", "county", "city", \
             "url_domain", "text_parser", "week", "age", "msa_name"
          promises = [Columns.get(props.source_column_id)]
        when "calculation"
          promises = (Columns.get(id) for k, id of props.source_column_ids)
        when "sequence"
          promises = [
            Columns.get(props.timestamp_column_id)
            Columns.get(props.owner_column_id)
          ]
        when "date_construct"
          ids = [
            props.year_column_id
            props.month_column_id
            props.day_column_id
            props.hour_column_id
            props.minute_column_id
            props.second_column_id
          ]
          promises = (Columns.get(id) for id in ids when id)
        when "date_diff"
          promises = [
            Columns.get(props.source_column_id)
            Columns.get(props.target_column_id)
          ]
        when "master_parent"
          promises = [
            Columns.get(props.source_column_id)
            Columns.get(props.parent_column_id)
            Columns.get(props.value_to_store_column_id)
          ]
        when "subscription_id"
          promises = [
            Columns.get(props.source_column_id)
            Columns.get(props.start_date_column_id)
            Columns.get(props.end_date_column_id)
          ]
        when "sequential_comparison"
          promises = [
            Columns.get(props.source_column_id)
            Columns.get(props.owner_column_id)
            Columns.get(props.timestamp_column_id)
          ]
        when "currency"
          promises = [
            Columns.get(props.timestamp_column_id)
            Columns.get(props.start_currency_column_id)
          ]
        when "relocated_field", "aggregate"
          promises = relocAggDependencies(column)
        else
          d = $q.defer()
          d.reject "Error finding dependencies for column " + column.id
          return d.promise

      deferred = $q.defer()
      $q.all(promises).then (deps) ->
        deferred.resolve deps
      , (e) ->
        deferred.reject e
      return deferred.promise

    Columns.buildDependencyTree = (column, cache = {}) ->
      helper = (currColumn, chain = []) ->
        deferred = $q.defer()
        if (id for id in chain when id == currColumn.id).length > 0
          deferred.reject "Circular dependency for column with id " + currColumn.id
        else if cache[currColumn.id]
          deferred.resolve cache[currColumn.id]
        else
          depsResolved = (deps) ->
            newChain = chain.concat [currColumn.id]
            promises = (helper c, newChain for c in deps)
            $q.all(promises).then (children) ->
              tree = {column: currColumn, children: children}
              cache[currColumn.id] = tree
              deferred.resolve tree
            , (e) ->
              deferred.reject e
          Columns.immediateDependencies(currColumn).then depsResolved, ->
            deferred.reject "Error getting dependencies for " + currColumn.id
        return deferred.promise

      return helper(column)

    Columns.buildDependencyTrees = (columns) ->
      cache = {}
      promises = (Columns.buildDependencyTree c, cache for c in columns)
      deferred = $q.defer()
      $q.all(promises).then (trees) ->
        deferred.resolve trees
      , (e) ->
        deferred.reject e
      return deferred.promise

    return Columns
  ]
)
